"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_UPLOAD = exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = void 0;
const client_1 = require("@apollo/client");
exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = (0, client_1.gql) `
  fragment AllAttachedGarageCrawlspaceInfo on AttachedGarageCrawlspaceInfo {
    sqft
    netAreaOfFloodOpenings
    numFloodOpenings
    engineeredFloodOpenings
    oneFloodOpeningTwoSides
    numNonEngineeredOpenings
    numEngineeredOpenings
    netAreaNonEngineeredOpenings
    ratedAreaOfEngineeredOpenings
  }
`;
exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = (0, client_1.gql) `
  fragment DocumentUploadDataFragment on DocumentUpload {
    id
    originalFilename
    name
    formData
    formStructure @skip(if: $isGuest)
    createdAt
    isDeletable @skip(if: $isGuest)
    hasAssociatedAIActionRun

    accountDocumentType {
      id
      name
      color
      allowedMimeTypes
      attachments {
        type
        customMapIds
      }
      order
      isSensitive
      documentType {
        id
        name
      }
    }
    issuedAt
    hiddenFromPublic
    mimeType

    submission @skip(if: $isGuest) {
      id
      formData
      tags {
        text
        display: tagDisplay
        uiSchemaPath
      }
      submissionTypeVersion {
        id
        submissionType {
          id
          name
          description
        }
      }
    }
  }
`;
exports.DOCUMENT_UPLOAD = (0, client_1.gql) `
  query getDocumentUpload($id: ID!, $isGuest: Boolean!) {
    documentUpload(id: $id) {
      ...DocumentUploadDataFragment

      objectType
      objectId
      property {
        id
        fullAddress
        latitude
        longitude
        hiddenFromPublic
      }

      customMapGeometry {
        id
        customMapId
      }

      elevationCertificate {
        id
        buildingOwnerName
        errorDetectionEligibility {
          status
          heading
          note
        }
        type
        propertyDescription
        buildingUse
        latitude
        longitude
        buildingDiagramNumber
        firmIndexDate
        firmPanelEffectiveDate
        floodZone
        baseFloodElevation
        baseFloodElevationDatum
        baseFloodElevationSource
        isBuildingLocatedInCbrsOrOpa
        buildingLocatedInCbrsOrOpaDesignationDate
        buildingLocatedInCbrsOrOpa
        buildingLocatedSeawardOfLimwa
        benchmarkUtilized
        elevationDatum
        verticalDatum
        elevationDatumComments
        buildingElevationSource
        buildingElevationInfo {
          topOfBottomFloor {
            value
            units
          }
          topOfNextHigherFloor {
            value
            units
          }
          bottomOfLowestHorizontalStructuralMember {
            value
            units
          }
          attachedGarage {
            value
            units
          }
          lowestElevationOfMachineryOrEquipment {
            value
            units
          }
          lowestAdjacentGrade {
            value
            units
            type
          }
          highestAdjacentGrade {
            value
            units
            type
          }
          lowestAdjacentGradeAtLowestElevationOfDeckOrStairs {
            value
            units
          }
        }
        issuedAt
        comments
        coordinatesProvidedBySurveyor
        conversionFactorUsed
        streetAddress
        nfipCommunityName
        nfipCommunityNumber
        nfipCountyName
        nfipState
        state
        city
        zipcode
        certifierName
        certifierLicenseNumber
        certifierInfo {
          name
          licenseNumber
          email
          telephone
        }
        firmMapNumber
        firmSuffix
        extractedData
        finishedConstruction
        formYear
        attachedGarageInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        crawlspaceInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        buildingMeasurementInfo {
          measurementsBasedOn
          topOfBottomFloorElevatedPerOrdinance
          offsets {
            topOfBottomFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfBottomFloorAboveOrBelowLag {
              value
              units
              aboveOrBelow
            }
            nextHigherFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            attachedGarageTopOfSlabAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfMachineryPlatformAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
          }
        }
        communityInfo {
          sectionCTakenFromOtherAuthorizedSource
          sectionECompletedByLocalOfficial
          sectionHCompletedByLocalOfficial
          sectionGCommentsProvidedByLocalOfficial
          communityInfoProvidedForFloodplainManagementPurposes
          permitNumber
          permitDateIssued
          certificateOfComplianceOrOccupancyDateIssued
          permitIssuedForNewConstructionOrSI
          elevations {
            asBuiltLowestFloor {
              value
              units
              datum
            }
            bottomOfAsBuiltLowestHorizontalStructuralMember {
              value
              units
              datum
            }
            bfeOrDepthOfFloodingAtBuildingSite {
              value
              units
              datum
            }
            communityMinimumRequirementOfLowestFloorOrLowestHorizontalStructuralMember {
              value
              units
              datum
            }
          }
          varianceIssued
          localOfficialInfo {
            name
            telephone
            email
            dateSigned
            comments
          }
        }
        permit @skip(if: $isGuest) {
          id
          permitNumber
          permitDate
          type
          final
          floodProofingCertificateRequired
          vZoneDesignCertificateRequired
          comments
        }
        validationErrors {
          data {
            errorCode
            id
            issue
            type
            value
            valueAttr
            field
            note
            ignored
            ignoredReason @skip(if: $isGuest)
          }
          count
        }
        firms {
          id
          name
          floodway
          jurisdictions
          useForRegulation
          datum
          stringStaticBFE
          stringDepth
          isApproximateBfe
          mscLink
          coastalA
          panels {
            panelNumber
          }
          zones {
            floodzone
            floodway
            coastalA
            stringStaticBFE
            stringDepth
            datum
          }
        }
      }

      certificateUpload {
        id
        cancelationReason @skip(if: $isGuest)
        status
        lowConfidence @skip(if: $isGuest)
      }
    }
  }

  ${exports.DOCUMENT_UPLOAD_DATA_FRAGMENT}
  ${exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO}
`;
(0, client_1.gql) `
  mutation UploadDocuments($data: CreateDocumentUploadsInput!) {
    createDocumentUploads(data: $data)
  }
`;
//# sourceMappingURL=data:application/json;base64,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